export default __webpack_public_path__ + "static/media/guitar.d91af019.svg";